import { useContext, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { FireBaseContext } from "../../Context/FireBase";
import { deleteDoc, doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import swal from "sweetalert";

export default function DeletedSubSetting({ rowId }) {
  const { SubscribersDeletedRef, SubscribersRefrence, EventRefrence } =
    useContext(FireBaseContext);

  const ITEM_HEIGHT = 38;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const returnData = async (id) => {
    try {
      const ref = doc(SubscribersDeletedRef, id);
      const item = await getDoc(ref);

      if (item.exists()) {
        const itemData = item.data();
        const docId = itemData.id;
        const costToRestore = itemData.CostperDelegate;

        // Add the item to the SubscribersRefrence collection
        const subscribersRef = doc(SubscribersRefrence, docId);
        await setDoc(subscribersRef, { ...itemData });

        // Fetch the current eventCost
        const eventRef = doc(EventRefrence, itemData.event);
        const eventDoc = await getDoc(eventRef);

        if (eventDoc.exists()) {
          const currentEventCost = eventDoc.data().eventCost;

          // Update the eventCost by adding the CostperDelegate of the restored subscriber
          const updatedEventCost = currentEventCost + costToRestore;
          await updateDoc(eventRef, { eventCost: updatedEventCost });
        }

        // Delete the original document from SubscribersDeletedRef
        await deleteDoc(ref);
        swal({
          icon: "success",
          text: "Restored Subscriber Successfully",
        });
      } else {
        console.error("Subscriber not found in deleted collection.");
      }
    } catch (error) {
      console.error("Error restoring subscriber:", error);
    }
  };

  const DeleteForever = async (id) => {
    const ref = doc(SubscribersDeletedRef, id);
    await deleteDoc(ref);
    swal({
      icon: "success",
      text: "Subscriber Deleted Successfully",
    });
  };
  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "15ch",
          },
        }}
      >
        <MenuItem onClick={() => returnData(rowId)}>
          <div className="d-flex   justify-content-start align-items-center w-75  gap-2 text-primary">
            <i className="fa-solid fa-floppy-disk"></i>
            <span className="   w-75 "> Restore</span>
          </div>
        </MenuItem>
        <MenuItem onClick={() => DeleteForever(rowId)}>
          <div className="d-flex   justify-content-start align-items-center w-75  gap-2 text-danger">
            <i className={`fa-solid fa-trash `}></i>
            <span className="   w-75 r">Delete</span>
          </div>
        </MenuItem>
      </Menu>
    </div>
  );
}
